import styled from 'styled-components';
import { COLORS, FONTS } from '@app/src/ui';
import { Button } from '@app/src/components/Button';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;

  @media(max-width: 768px) {
    flex-direction: column;
    align-items: flex-end;
    margin-bottom: 24px;
    padding: 0 20px;
  }
`;

export const FormWrapper = styled.form`
  display: flex;
  width: 100%;
  padding: 0 16px;
  margin-top: 29px;

  @media(max-width: 768px) {
    padding: 0;
    flex-direction: column;
  }
`;

export const FieldWrapper = styled.div`
  display: flex;
  width: 190px;

  @media(max-width: 768px) {
    width: 100%;
  }
`;

export const FieldPredictive = styled(FieldWrapper)`
  margin-right: 15px;
`;

export const Error = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 30px;
  font-size: 14px;
  font-family: ${FONTS.ROBOTO_REGULAR};
  color: ${COLORS.ERROR_RED};
  padding: 0 16px;

  @media(min-width: 768px) {
    padding: 0;
  }
`;

export const WrapperButton = styled(Button)`
  background: ${COLORS.YELLOW};
  min-width: 195px;
  div {
    height: 16px;
    svg {
      height: 100%;
    }
  }
  &: hover {
    background: #eabe08;
  }
`;
